import React from 'react';
import { StatefulDatePicker } from '@components/StatefulInputs/StatefulDatePicker/StatefulDatePicker';
import { useFormContext } from 'react-hook-form';
import { RequestFormValidatedState } from '@interfaces/RequestForm/forms/RequestFormValidatedState';
import {
	NewRequestedDateValidation,
} from '@components/RequestForm/RequestFormValidation';

export const RequestedDate = () => {
	const { watch, clearErrors, formState } = useFormContext<RequestFormValidatedState>();
	const [ roomId ] = watch(['roomId']);

	//This is needed to clear the date value from the formState when clearing the selection from openAvailabilityCalendar
	React.useEffect(() => {
		if (roomId && formState.errors.procedureDate) {
			clearErrors('procedureDate');
		}
	}, [clearErrors, formState.errors.procedureDate, roomId]);

	return (
		<StatefulDatePicker
			name="procedureDate"
			label="Requested date"
			extraLabel="(MM/DD/YYYY)"
			placeholder=""
			styleAsRequired={true}
			controllerOptions={{
				rules: { ...NewRequestedDateValidation },
			}}
			dataField="requestForm-requestDetails-procedureDatePicker"
		/>
	);
};
